import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.adminpage.foradmin');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-adminpage-foradmin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.adminpage.foradmin/view.scss */
/* src/app/portal.adminpage.foradmin/view.scss: no such file or directory */`],
})
export class PortalAdminpageForadminComponent implements OnInit {
    public users: any[] = [];
    public session: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();

        this.session = this.service.auth.session;

        // 비관리자 접근 금지
        if (this.session.role !== 'admin') {
            location.href = "/ui/dashboard";
            return;
        }
        await this.loadUsers();

        await this.service.render();
    }

    public async loadUsers() {
        const res = await wiz.call("get_users", {});
        this.users = res.data || [];
        await this.service.render();
    }

    public async toggleRole(user: any) {
        if (user.email === this.session.email) {
            return; // 자기 자신 변경 금지
        }

        const newRole = user.role === "admin" ? "user" : "admin";

        const ok = confirm(
            `권한을 변경하시겠습니까?\n\n` +
            `이름: ${user.name}\n` +
            `이메일: ${user.email}\n` +
            `변경: ${user.role} → ${newRole}`
        );

        if (!ok) {
            return;
        }

        const res = await wiz.call("update_user_role", {
            user_id: user.id,
            role: newRole,
        });

        if (res?.code === 200) {
            user.role = newRole;
        } else {
            alert(res?.data?.error || "권한 변경에 실패했습니다.");
        }

        await this.service.render();
    }

    public async deleteUser(user: any) {
        if (user.email === this.session.email) return; // 자기 자신 삭제 금지

        const ok = confirm(
            `정말 삭제하시겠습니까?\n\n` +
            `이름: ${user.name}\n` +
            `이메일: ${user.email}\n\n` +
            `삭제 후 복구할 수 없습니다.`
        );

        if (!ok) {
            return;
        }

        const res = await wiz.call("delete_user", { user_id: user.id });

        if (res?.code === 200) {
            this.users = this.users.filter(u => u.id !== user.id);
        } else {
            alert(res?.data?.error || "사용자 삭제에 실패했습니다.");
        }

        await this.service.render();
    }
}

export default PortalAdminpageForadminComponent;